import { Link } from 'wouter';
import Telegram from '@/assets/svg/telegram.svg?react';
import Vk from '@/assets/svg/vk.svg?react';
import LogoH from '@/assets/svg/logo-h.svg';

export function Footer() {
  return (
    <footer className="mt-12">
      <div className="main-container transition-all duration-300">
        <div className="flex gap-9 sm:gap-14 py-10 flex-wrap sm:items-start items-center sm:justify-between  justify-around flex-col sm:flex-row">
          <Link to="/">
            <img
              src={LogoH}
              alt="Квиз, плиз!"
              className="w-[110px] cursor-pointer hover:scale-105"
            />
          </Link>

          <nav>
            <ul className="font-normal flex lg:flex-row flex-col no-wrap gap-6 text-center sm:text-left items-center">
              <li>
                <a
                  href="https://quizplease.ru/schedule?QpGameSearch%5Bformat%5D=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  Расписание игр в барах
                </a>
              </li>
              <li>
                <a
                  href="https://quizplease.ru/shop"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  Магазин
                </a>
              </li>
              <li>
                <a
                  href="https://franch.quizplease.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  Франшиза
                </a>
              </li>
              <li>
                <a
                  href="https://quizplease.ru/corp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  Корпоративы
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="border-t py-8 border-[#A9A8A8] flex justify-center md:justify-between gap-4 items-center flex-wrap [&_svg]:fill-white">
          <div className="flex gap-3">
            <a
              href="https://t.me/quizplease_moscow "
              className="hover:[&_svg]:fill-white/50"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Telegram />
            </a>
            <a
              href="https://vk.com/quiz_please"
              className="hover:[&_svg]:fill-white/50"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Vk />
            </a>
          </div>

          <nav>
            <ul className="text-[#A9A8A8] font-normal underline space-y-1 text-center md:text-left">
              <li>
                <a
                  href="https://quizplease.ru/agreement"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white/50"
                >
                  Соглашение на обработку персональных данных и получение рассылки
                </a>
              </li>
              <li>
                <a
                  href="https://quizplease.ru/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white/50"
                >
                  Политика в отношении персональных данных
                </a>
              </li>
              <li>
                <a
                  href="https://quizplease.ru/rules"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white/50"
                >
                  Пользовательское соглашение
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
}
